import React, { Component } from 'react';
import Parser from 'html-react-parser'
import { ArrowIcon, DocumentIcon, ChevronRightIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';

class First extends Component {
  static defaultProps = {

  }

  state = {

  }

  constructor(props) {
    super(props);
    this.state = {
      showCallForm: false,
    };
  }

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {

    const data = this.props?.data || {}
    const catalog = data?.catalog || []
    const himdir = data?.himdir || {}
    const { showCallForm } = this.state

    return (
      <>
        <div className='mt-[40px] w-full'>
          <div className='container'>
            <div className='uppercase tracking-tight text-title text-ptblack leading-none'>{Parser(data?.h1 || data?.pagetitle)}</div>
            <div className='text-base text-ptgray mt-[12px] leading-none'>{Parser(data?.introtext)}</div>
            {catalog.map((el, k) => (
              <div key={k} className='mt-[40px]'>
                <div className='flex flex-col xl:flex-row items-start gap-[20px]'>
                  <div className='flex xl:hidden items-start justify-start w-full'>
                    <div className='p-[20px] bg-[#F6F7F8] rounded-[14px] text-ptgray text-base font-light'>
                      {el.text}
                    </div>
                  </div>
                  <div className='flex w-full xl:w-auto xl:grid grid-cols-3 gap-[10px] flex-1 overflow-x-auto overflow-y-hidden pb-[10px] xl:pb-[0px]'>
                    {el.products.map( ( cel ) => (
                      <div className='w-[228px] flex-none xl:w-auto xl:flex-1'>
                        <a href={cel?.href} style={{ backgroundImage: `url('${cel?.image}')` }} className='w-full h-[200px] bg-[#F6F7F8] bg-contain bg-no-repeat bg-left rounded-[14px] p-[20px] flex justify-end items-end gap-[35px]'>
                          <div className="w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-white text-[#141414] cursor-pointer">
                            <ChevronRightIcon width={6} height={12} stroke="currentColor" />
                          </div>
                        </a>
                        <div className='uppercase text-cardTitle text-ptblack leading-none mt-[20px]'>{cel?.name}</div>
                        <div className='text-base text-ptgray leading-none mt-[12px]'>{cel?.text}</div>
                      </div>
                    ) )}
                  </div>
                  <div className="w-full xl:w-[386px] flex-none">
                    <div
                      className='w-full rounded-[14px] overflow-hidden bg-center bg-cover bg-no-repeat relative'
                      style={{ backgroundImage: `url('${el.image}')` }}
                    >
                      {/* Градиентный слой - появляется только при наведении */}
                      <div className='hidden xl:block absolute inset-0 bg-gradient-to-t from-[#001351]/20 to-[#00071E] transition-all duration-300'></div>
                      
                      {/* Контент всегда виден */}
                      <div className='relative z-10 w-full h-[220px] xl:h-[260px] flex flex-col items-center justify-end xl:justify-between p-[20px]'>
                        
                        <div className='hidden xl:block text-white font-light leading-none text-cardTitle uppercase w-full transition-all duration-300'>
                          <div className='max-w-[253px]'>
                            {el.title}
                          </div>
                        </div>
                        
                        <div className='w-full flex justify-end'>
                          {/* Белый контейнер с меняющейся шириной - всегда виден */}
                          <a href={el?.href} className='cursor-pointer bg-white duration-300 ease-in-out hover:bg-[#DBE7F3] h-[38px] flex items-center justify-end rounded-[14px] overflow-hidden'>
                            
                            {/* Внутренний блок с фиксированной шириной */}
                            <div className='flex items-center gap-[12px] px-[12px]'>
                              
                              {/* Текст появляется при наведении */}
                              <div className='hidden xl:block text-base whitespace-nowrap'>
                                Перейти в категорию
                              </div>
                              
                              {/* Стрелка всегда видна */}
                              <ArrowIcon width={16} height={16} stroke="currentColor" className="flex-shrink-0" />
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='xl:hidden mt-[20px] w-full text-ptblack leading-none text-cardTitle uppercase'>
                      {el.title}
                    </div>
                  </div>
                </div>
                <div className='mt-[20px] hidden xl:flex items-start justify-start w-full'>
                  <div className='p-[20px] bg-[#F6F7F8] rounded-[14px] text-ptgray text-base font-light'>
                    {el.text}
                  </div>
                </div>
              </div>
            ))}
            <div className='flex-col xl:flex-row mt-[40px] flex items-start gap-[20px]'>
              <div className="w-full xl:w-[386px] flex-none">
                <div
                  className='w-full rounded-[14px] overflow-hidden bg-center bg-cover bg-no-repeat relative'
                  style={{ backgroundImage: `url('${himdir?.image}')` }}
                >
                  {/* Градиентный слой - появляется только при наведении */}
                  <div className='hidden xl:block absolute inset-0 bg-gradient-to-t from-[#001351]/20 to-[#00071E]'></div>
                  
                  {/* Контент всегда виден */}
                  <div className='relative z-10 w-full h-[186px] flex flex-col items-center justify-between p-[20px]'>
                    
                    {/* Текст - появляется при наведении */}
                    <div className='hidden xl:block text-white font-light leading-none text-cardTitle uppercase w-full'>
                      <div className='max-w-[253px]'>
                        {himdir?.name}
                      </div>
                    </div>
                    
                    <div className='w-full flex justify-end'>
                      {/* Белый контейнер с меняющейся шириной - всегда виден */}
                      <a href={himdir?.href} className='cursor-pointer bg-white duration-300 ease-in-out hover:bg-[#DBE7F3] h-[38px] flex items-center justify-end rounded-[14px] overflow-hidden'>
                        
                        {/* Внутренний блок с фиксированной шириной */}
                        <div className='flex items-center gap-[12px] px-[12px]'>
                          
                          {/* Текст появляется при наведении */}
                          <div className='hidden xl:block text-base whitespace-nowrap'>
                            Перейти в категорию
                          </div>
                          
                          {/* Стрелка всегда видна */}
                          <ArrowIcon width={16} height={16} stroke="currentColor" className="flex-shrink-0" />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className='xl:hidden mt-[20px] w-full text-ptblack leading-none text-cardTitle uppercase'>
                  {himdir?.name}
                </div>
              </div>
              <div style={{ backgroundImage: `url('src/images/ceni_bg.png')` }} className='w-full xl:w-auto bg-cover bg-center flex-col xl:flex-row flex-auto xl:h-[186px] bg-[#001553] rounded-[14px] flex items-center justify-between gap-[19px] p-[20px]'>
                <div className='leading-none'>
                  <div className='text-white font-light leading-none text-cardTitle uppercase'>Нужны цены и условия поставки?</div>
                  <div className='mt-[12px] text-base text-white/60'>
                    Оставьте запрос — <span className='text-white'>подготовим коммерческое предложение</span> под ваш 
                    объём, тару и регион. <span className='text-white'>Приложим документы</span> на продукцию и <span className='text-white'>уточним 
                    сроки</span> отгрузки.
                  </div>
                  <div onClick={() => this.openCallForm()} className='cursor-pointer max-w-[343px] bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white mt-[27px]'>
                    <DocumentIcon width={16} height={16} stroke="currentColor" />
                    <div className='text-base'>Запросить КП</div>
                  </div>
                </div>
                <img src={data?.image} alt="123" className='w-full sm:w-auto flex-none h-auto' width={300} height={144} />
              </div>
            </div>
          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Запросить КП"
          formText="Оставьте свои контактные данные, и мы свяжемся с вами в ближайшее время."
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    )
  }
}

export default First;